import { createBrowserRouter, type RouteObject, RouterProvider } from "react-router"
import { UnauthorizedPage } from "@/domains/unauthorized/pages/UnauthorizedPage/UnauthorizedPage"
import { Layout } from "../layout/Layout"
import { RouterErrorBoundary } from "./RouterErrorBoundary/RouterErrorBoundary"

const unauthorizedRoutes: RouteObject[] = [
  {
    path: "*",
    element: <Layout isUnauthorized={true} />,
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        path: "*",
        errorElement: <RouterErrorBoundary />,
        element: <UnauthorizedPage />
      }
    ]
  }
]

export function UnauthorizedRouter() {
  return <RouterProvider router={createBrowserRouter(unauthorizedRoutes)} />
}
